import { BASE_URL } from "../../../shared/utils/variables";
import { getAuthHeaders } from "../../../shared/services/authentication";
import { Beneficiary } from "../../../shared/interfaces/beneficiary";
import { BeneficiaryType } from "../../../shared/interfaces/beneficiary-type";
import { DeleteImpactResponse } from "../../../shared/interfaces/delete-impact";

const baseURL = BASE_URL;

// Buscar todos os beneficiários
export const fetchBeneficiariesService = async (): Promise<Beneficiary[]> => {
    const url = `${baseURL}/beneficiaries`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Buscar beneficiários por ID da empresa
export const fetchBeneficiariesByIdCompanyService = async (idCompany: string): Promise<Beneficiary[]> => {
    const url = `${baseURL}/beneficiary/company/${idCompany}`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Buscar beneficiário específico por ID
export const fetchBeneficiaryService = async (id: string): Promise<Beneficiary> => {
    const url = `${baseURL}/beneficiary/${id}`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Criar novo beneficiário
export const createBeneficiaryService = async (beneficiary: Beneficiary): Promise<Beneficiary> => {
    const url = `${baseURL}/beneficiary`;

    const options = {
        method: 'POST',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(beneficiary),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Atualizar beneficiário existente
export const updateBeneficiaryService = async (id: string, beneficiary: Beneficiary): Promise<Beneficiary> => {
    const url = `${baseURL}/beneficiary/${id}`;

    const options = {
        method: 'PUT',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(beneficiary),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Deletar beneficiário
export const deleteBeneficiaryService = async (id: string, forceDelete = false): Promise<void> => {
    const url = `${baseURL}/beneficiary/${id}${forceDelete ? '?force=true' : ''}`;

    const options = {
        method: 'DELETE',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }
};

export const fetchBeneficiaryDeleteImpactService = async (id: string): Promise<DeleteImpactResponse> => {
    const url = `${baseURL}/beneficiary/${id}/delete-impact`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};


// Buscar tipos de beneficiários
export const fetchBeneficiaryTypesService = async (): Promise<BeneficiaryType[]> => {
    const url = `${baseURL}/beneficiary-type`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

export default {
    fetchBeneficiariesService,
    fetchBeneficiariesByIdCompanyService,
    fetchBeneficiaryService,
    createBeneficiaryService,
    updateBeneficiaryService,
    deleteBeneficiaryService,
    fetchBeneficiaryTypesService
};
